import * as React from 'react';
import PropType from 'prop-types';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

function NDropdown(props) {
  const { value, label, onChange, options, id, multiple, onBlur } = props;

  const ITEM_HEIGHT = 80;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };

  return (
    <div className='App-inputs input-dropdown'>
      <FormControl fullWidth error={props?.error}>
        <InputLabel id={`n-dropdown-select-label${label}`}>{label}</InputLabel>
        <Select
          labelId={`n-dropdown-select-label${label}`}
          id={id}
          value={value}
          label={label}
          onChange={onChange}
          multiple={multiple}
          MenuProps={MenuProps}
          onBlur={onBlur}
          {...props}
        >
          {options?.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {multiple ? (
                <>
                  <Checkbox checked={value.indexOf(o.value) > -1} />
                  {o.label}
                </>
              ) : (
                o.label
              )}
            </MenuItem>
          ))}
        </Select>
        {props?.helperText && <FormHelperText>{props?.helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
}

NDropdown.propTypes = {
  id: PropType.string,
  error: PropType.bool,
  multiple: PropType.bool,
  value: PropType.oneOfType([PropType.string, PropType.number]),
  label: PropType.string,
  helperText: PropType.string,
  onChange: PropType.func,
  onBlur: PropType.func,
  options: PropType.arrayOf(
    PropType.shape({
      label: PropType.oneOfType([PropType.string, PropType.number]),
      value: PropType.oneOfType([PropType.string, PropType.number]),
    }),
  ),
};

NDropdown.defaultProps = {
  error: false,
  multiple: false,
  value: '',
  id: '',
  label: '',
  helperText: '',
  onChange: () => {},
  onBlur: () => {},
  options: undefined,
};

export default NDropdown;
